import { useLocation } from "react-router-dom";
import BottomNav from "./BottomNav";
import DesktopSidebar from "./DesktopSidebar";
import { useAuth } from "@/contexts/AuthContext";

/**
 * O cromo do app — navbar no celular, barra lateral no computador — montado
 * UMA vez, fora das telas e fora do Suspense.
 *
 * Antes, cada tela desenhava a própria navbar dentro do seu AppLayout. Trocar
 * de aba desmontava uma navbar e montava outra; e enquanto o pacote da tela
 * nova baixava, o Suspense mostrava um esqueleto com uma TERCEIRA navbar, de
 * outro desenho. Resultado: a barra sumia e voltava a cada toque. Aqui ela
 * nunca sai do lugar; só a pílula de ouro desliza.
 *
 * Telas públicas e telas de foco (login, obrigado, termos, receita pública,
 * modo cozinha) não têm cromo. A regra mora aqui, num lugar só.
 *
 * Clean Cakes e Clean Mornings já tiveram navbar própria (namespace). Não
 * têm mais: são produtos como os outros — capa em Meus conteúdos, a mesma
 * navbar, o mesmo Saved e o mesmo More (decisão do dono, 25/09).
 */
const SEM_CROMO = [
  /^\/login$/,
  /^\/clean-cakes\/login$/,
  /^\/clean-mornings\/login$/,
  /\/cooking$/,
  /^\/r\//,
  /^\/terms-of-service$/,
  /^\/privacy-policy$/,
  /^\/thank-you$/,
  /^\/chef\.natasha\.perez$/,
];

const Chrome = () => {
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) return null;
  if (SEM_CROMO.some((re) => re.test(pathname))) return null;

  return (
    <>
      <DesktopSidebar />
      <BottomNav />
    </>
  );
};

export default Chrome;
